export const USER_PRIVACY_SETTING_SHOW_FULL_NAME = 1
export const USER_PRIVACY_SETTING_SHOW_FIRST_LAST_INITIAL = 2
export const USER_PRIVACY_SETTING_SHOW_USERNAME = 3
export const USER_PRIVACY_SETTING_SHOW_AS_ANONYMOUS = 4
